import * as trackingApi from 'Tracking/tracking-api';
import { BE_GA_DEFAULT_PAYLOAD } from 'Views/booking/constants';
export function trackClick(labelGA: string, appContext: AppContext) {
  trackingApi.setDataLayer(
    { ...BE_GA_DEFAULT_PAYLOAD, versionBooking: 'responsive', actionGA: 'summary', labelGA },
    appContext,
  );
}
